export const CHAIN_START = new Date('2018-12-31T00:00:00.000Z');

export const NETWORK_CONSTANTS = {
  TARGET_BLOCK_TIME: 120, // seconds
  DIFFICULTY_ADJUSTMENT_INTERVAL: 2016, // blocks
  INITIAL_BLOCK_REWARD: 50,
  HALVING_INTERVAL: 210000, // blocks
} as const;